// Fase 2 — Smart Sections library: pre-configured guest-guide sections grouped by
// category, each with ready-made "smart" blocks (structured fields) instead of an empty box.

export const SECTION_CATEGORIES = [
  { key: "comfort", label: "Comfort" },
  { key: "family", label: "Famiglia" },
  { key: "structure", label: "Struttura" },
  { key: "services", label: "Servizi" },
  { key: "mobility", label: "Mobilità" },
];

// Each section: { key(unique), category, title, subtitle, icon, keywords, blocks:[{type,content}] }
export const SMART_SECTIONS = [
  // ---------------- Comfort ----------------
  {
    key: "pool", category: "comfort", title: "Piscina", subtitle: "Orari e regole", icon: "pool", keywords: "piscina nuoto pool",
    blocks: [
      { type: "hours", content: { label: "Orari di apertura", value: "" } },
      { type: "list", content: { items: ["Doccia prima di entrare in acqua", "Bambini sempre sorvegliati", "Vietato tuffarsi"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "spa", category: "comfort", title: "Spa & Sauna", subtitle: "Relax e benessere", icon: "bath", keywords: "spa sauna idromassaggio jacuzzi",
    blocks: [
      { type: "hours", content: { label: "Orari", value: "" } },
      { type: "list", content: { items: ["Come accendere la sauna", "Durata consigliata", "Precauzioni"] } },
    ],
  },
  {
    key: "terrace", category: "comfort", title: "Terrazza & Balcone", subtitle: "Lo spazio all'aperto", icon: "terrace", keywords: "terrazza balcone giardino esterno",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "list", content: { items: ["Riporta i cuscini in caso di pioggia", "Rispetta gli orari di silenzio"] } },
    ],
  },
  {
    key: "aircon", category: "comfort", title: "Aria condizionata", subtitle: "Come usarla", icon: "snow", keywords: "aria condizionata clima climatizzatore freddo",
    blocks: [
      { type: "steps", content: { title: "Come usare il climatizzatore", steps: [
        { text: "Accendi con il telecomando", image: "" },
        { text: "Imposta la temperatura desiderata", image: "" },
        { text: "Spegni sempre quando esci dalla stanza", image: "" },
      ] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "heating", category: "comfort", title: "Riscaldamento", subtitle: "Come regolarlo", icon: "flame", keywords: "riscaldamento termosifoni caldo termostato",
    blocks: [
      { type: "list", content: { items: ["Come regolare il termostato", "Orari consigliati"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "fireplace", category: "comfort", title: "Camino", subtitle: "Uso in sicurezza", icon: "flame", keywords: "camino stufa legna fuoco",
    blocks: [
      { type: "list", content: { items: ["Usa solo la legna fornita", "Non lasciare mai il fuoco incustodito", "Chiudi lo sportello"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  // ---------------- Famiglia ----------------
  {
    key: "kids", category: "family", title: "Per i bambini", subtitle: "Dotazioni e sicurezza", icon: "baby", keywords: "bambini famiglia culla seggiolone",
    blocks: [
      { type: "list", content: { items: ["Culla disponibile su richiesta", "Seggiolone", "Fasciatoio"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "pets", category: "family", title: "Animali ammessi", subtitle: "Pet policy", icon: "pet", keywords: "animali cani gatti pet",
    blocks: [
      { type: "list", content: { items: ["Sempre al guinzaglio negli spazi comuni", "Non lasciarli soli in casa", "Pulisci gli eventuali bisogni"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "entertainment", category: "family", title: "Intrattenimento", subtitle: "Giochi e svago", icon: "tv", keywords: "giochi intrattenimento libri console",
    blocks: [
      { type: "list", content: { items: ["Giochi da tavolo", "Libri e riviste", "Console / streaming"] } },
    ],
  },
  // ---------------- Struttura ----------------
  {
    key: "washer", category: "structure", title: "Lavatrice", subtitle: "Istruzioni d'uso", icon: "washer", keywords: "lavatrice bucato lavaggio",
    blocks: [
      { type: "steps", content: { title: "Come usare la lavatrice", steps: [
        { text: "Aggiungi il detersivo nell'apposito cassetto", image: "" },
        { text: "Seleziona il programma di lavaggio", image: "" },
        { text: "Avvia il ciclo con il pulsante Start", image: "" },
      ] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "dishwasher", category: "structure", title: "Lavastoviglie", subtitle: "Come usarla", icon: "info", keywords: "lavastoviglie piatti stoviglie",
    blocks: [
      { type: "steps", content: { title: "Come usare la lavastoviglie", steps: [
        { text: "Inserisci la pastiglia detergente", image: "" },
        { text: "Seleziona il programma", image: "" },
        { text: "Avvia il ciclo", image: "" },
      ] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "smart_tv", category: "structure", title: "Smart TV", subtitle: "Come funziona", icon: "tv", keywords: "tv televisione netflix streaming",
    blocks: [
      { type: "steps", content: { title: "Come usare la Smart TV", steps: [
        { text: "Accendi con il telecomando", image: "" },
        { text: "Seleziona la sorgente HDMI corretta", image: "" },
        { text: "Accedi con il tuo account streaming personale", image: "" },
      ] } },
    ],
  },
  {
    key: "safe", category: "structure", title: "Cassaforte", subtitle: "Come usarla", icon: "key", keywords: "cassaforte sicurezza valori",
    blocks: [
      { type: "steps", content: { title: "Come usare la cassaforte", steps: [
        { text: "Imposta un codice a tua scelta", image: "" },
        { text: "Chiudi lo sportello e conferma", image: "" },
        { text: "Per aprirla, digita il codice e premi il tasto di apertura", image: "" },
      ] } },
      { type: "info", content: { label: "Posizione", value: "" } },
    ],
  },
  {
    key: "elevator", category: "structure", title: "Ascensore", subtitle: "Accesso e uso", icon: "info", keywords: "ascensore piano montacarichi",
    blocks: [
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "waste", category: "structure", title: "Raccolta differenziata", subtitle: "Come e quando", icon: "trash", keywords: "rifiuti differenziata spazzatura immondizia",
    blocks: [
      { type: "list", content: { items: ["Organico", "Plastica e lattine", "Carta", "Vetro", "Indifferenziato"] } },
      { type: "hours", content: { label: "Giorni di ritiro", value: "" } },
      { type: "text", content: { text: "" } },
    ],
  },
  // ---------------- Servizi ----------------
  {
    key: "breakfast", category: "services", title: "Colazione", subtitle: "Cosa trovi", icon: "coffee", keywords: "colazione breakfast caffè cornetti",
    blocks: [
      { type: "hours", content: { label: "Orario", value: "" } },
      { type: "list", content: { items: ["Caffè e tè", "Cornetti / biscotti", "Latte e succhi"] } },
    ],
  },
  {
    key: "cleaning", category: "services", title: "Pulizie", subtitle: "Frequenza e info", icon: "sparkles", keywords: "pulizie cambio biancheria asciugamani",
    blocks: [
      { type: "hours", content: { label: "Frequenza", value: "" } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "late_checkout", category: "services", title: "Late check-out", subtitle: "Su richiesta", icon: "clock", keywords: "late checkout tardi partenza",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "info", content: { label: "Costo", value: "" } },
    ],
  },
  {
    key: "luggage", category: "services", title: "Deposito bagagli", subtitle: "Prima e dopo", icon: "luggage", keywords: "bagagli valigie deposito",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "hours", content: { label: "Disponibilità", value: "" } },
    ],
  },
  {
    key: "bike_rental", category: "services", title: "Noleggio bici", subtitle: "Esplora i dintorni", icon: "bike", keywords: "bici biciclette noleggio bike",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "info", content: { label: "Prezzo", value: "" } },
    ],
  },
  // ---------------- Mobilità ----------------
  {
    key: "airport_transfer", category: "mobility", title: "Transfer aeroporto", subtitle: "Come organizzarlo", icon: "plane", keywords: "transfer aeroporto navetta taxi",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "phone", content: { label: "Contatto transfer", value: "" } },
      { type: "info", content: { label: "Prezzo indicativo", value: "" } },
    ],
  },
  {
    key: "public_transport", category: "mobility", title: "Trasporti pubblici", subtitle: "Fermate e linee", icon: "bus", keywords: "autobus bus metro tram treno fermata",
    blocks: [
      { type: "list", content: { items: ["Fermata più vicina", "Linee utili", "Dove comprare i biglietti"] } },
      { type: "text", content: { text: "" } },
    ],
  },
  {
    key: "car_rental", category: "mobility", title: "Noleggio auto", subtitle: "Info utili", icon: "car", keywords: "noleggio auto macchina rent",
    blocks: [
      { type: "text", content: { text: "" } },
      { type: "phone", content: { label: "Contatto", value: "" } },
    ],
  },
  {
    key: "taxi", category: "mobility", title: "Taxi & NCC", subtitle: "Numeri utili", icon: "car", keywords: "taxi ncc auto conducente",
    blocks: [
      { type: "phone", content: { label: "Numero taxi", value: "" } },
      { type: "text", content: { text: "" } },
    ],
  },
];
